var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "invitation-notification__container" }, [
    _vm.invitation
      ? _c("div", { staticClass: "alert alert-info" }, [
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.invitation.addedByUser.givenName) +
                "  " +
                _vm._s(_vm.invitation.addedByUser.familyName) +
                "\n            on kutsunut sinut buukkaa-bandi.fi- palveluun ja bändiin " +
                _vm._s(_vm.invitation.band.bandName) +
                ".\n        "
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }